module.exports = __webpack_public_path__ + "media/images/icons/tools-43ffa778da78abaa64c3b2f7919db2e6.svg";